import React from "react";
import { IconT } from "types/utils";

const SearchIcon = ({ height = "14", width = "14", fill = "currentColor" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none" aria-hidden>
      <circle cx="9" cy="9" r="6" stroke={fill} strokeWidth="2" />
      <path d="m14 14 4 4" stroke={fill} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
export default SearchIcon;
